import {useIntl} from "../hooks/use-intl";
import ReactMarkdown from 'react-markdown'

const IntlRenderer = ({id}) => {
    const {getTranslation} = useIntl();
    const translation = getTranslation(id);
    if (!translation) {
        throw new Error(`Translation with id ${id} does not exist`)
    }
    return <ReactMarkdown>{translation}</ReactMarkdown>
};

export default IntlRenderer;
